import { alpha, colors } from '@bridebook/ui';
import { FelaCSS } from '@bridebook/ui/src';
import { SharedTypes } from './final-screen';

interface PropTypes extends SharedTypes {}

interface IStyles {
  overlay: FelaCSS;
  seeMore: FelaCSS;
  linkStyle: FelaCSS;
  icon: FelaCSS;
  seeFullProfile: FelaCSS;
}

const styles = ({ style = {} }: PropTypes): IStyles => ({
  overlay: {
    position: 'absolute',
    zIndex: 2,
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    textAlign: 'center',
    backgroundColor: alpha(colors.space, 80),
    justifyContent: 'center',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    ...style,
  },

  seeMore: {
    color: colors.white,
    fontDefaultSemiBold: 15,
    textAlign: 'center',
    marginTop: '10px',
    lineHeight: '1.43em',
  },

  linkStyle: {
    alignItems: 'center',
    flexDirection: 'column',
  },

  seeFullProfile: {
    alignItems: 'center',
    flexFlow: 'row',
  },

  icon: {
    transform: 'rotate(-90deg)',
    top: '5px',
    left: '2px',
  },
});

export default styles;
